$(document).ready(function () {
	// Home banner slider
	$('.home_slider').slick({
		dots: false,
		fade: true,
		infinite: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true,
		speed: 700,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$('a[href="#"]').attr('href', 'javascript:void(0)');


	$('.home_feature_slider').slick({
		dots: false,
		infinite: false,
		arrows: true,
		speed: 500,
		infinite: true,
		centerMode: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		cssEase: 'linear',
		autoplay: false,
		prevArrow: $('.desktop-arrow-prev'),
		nextArrow: $('.desktop-arrow-next'),
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});



/*

	$('.instafeed_box').slick({
		dots: false,
		infinite: true,
		speed: 500,
		arrows: false,
		slidesToShow: 6,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrow: false,
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}
		]
	});*/


});


